var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 45,
    viewBox: "0 0 44 45",
    width: 44,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m32.5425 22.7615c0-.8155-.0693-1.6009-.2013-2.3523h-10.8413v4.4432h6.1904c-.2666 1.4375-1.0729 2.662-2.2948 3.4813v2.8907h3.7244c2.1733-2.002 3.4226-4.9633 3.4226-8.4629z",
    fill: "#4285f4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m25.3969 28.3336c-1.0285.69-2.351 1.0925-3.8969 1.0925-2.9926 0-5.5318-2.019-6.4387-4.7398h-3.8382v2.9782c1.8923 3.7584 5.7827 6.3355 10.2769 6.3355 3.1037 0 5.7173-1.0194 7.6213-2.7757z",
    fill: "#34a853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m14.7045 22.4998c0-.7605.1268-1.4963.3568-2.1863v-2.9795h-3.8381c-.7815 1.5538-1.2232 3.3075-1.2232 5.1658s.4417 3.6121 1.2232 5.1659l3.8381-2.9782c-.23-.6914-.3568-1.4271-.3568-2.1877z",
    fill: "#fbbc05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m21.5 15.5739c1.6897 0 3.2043.5815 4.3987 1.7197l3.2958-3.2958c-1.9929-1.8583-4.5921-2.9978-7.6945-2.9978-4.4942 0-8.3846 2.577-10.2769 6.3341l3.8382 2.9783c.9069-2.7195 3.4461-4.7385 6.4387-4.7385z",
    fill: "#ea4335"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.bb17e5b01d73d31273d919a7b33b86c0.svg";
export { ForwardRef as ReactComponent };